import * as Inovx from '@shared';
import OrganizationService from '../services/OrganizationServices';
import OrganizationConstants from '../constants/OrganizationConstants';
import OrganizationStore from '../stores/OrganizationStore';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

declare var InovxLoader: any;

function _endEdit() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: OrganizationConstants.ORGANIZATION_END_EDIT
    });
}

var OrganizationActions = {
    getAllRoot(itemType: number, callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean) {
        OrganizationService.getAllRoot(itemType, function (data) {
            if (callback !== undefined && callback != null) {
                callback();
            }

            Inovx.Shared.Flux.AppDispatcher.dispatch({
                actionType: OrganizationConstants.ORGANIZATION_RECIEVE_ROOTS,
                data: data
            });
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }, ignoreDefaultError);
    },

    getChildren(organization: IOrganizationBase, callback?: any) {
        OrganizationService.getChildren(organization,
            function (data) {
                if (callback !== undefined && callback != null) {
                    callback();
                }

                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: OrganizationConstants.ORGANIZATION_RECIEVE_CHILDREN,
                    parent: organization,
                    data: data
                });
            },
            function () { });
    },


    beginEdit(organization: IOrganizationBase) {
        OrganizationService.getAllRoles(function (roles: IOrganizationRole[]) {
            Inovx.Shared.Flux.AppDispatcher.dispatch({
                actionType: OrganizationConstants.ORGANIZATION_RECEIVE_ALL_ROLES,
                roles: roles
            });

            OrganizationService.getOrganizationDetail(organization.ID,
                function (organization: IItemDataDetail) {
                    Inovx.Shared.Flux.AppDispatcher.dispatch({
                        actionType: OrganizationConstants.ORGANIZATION_BEGIN_EDIT,
                        organization: organization
                    });
                }, function (error) {
                });
        }, function (error) {
        });
    },

    endEdit() {
        if (OrganizationStore.getHasChanges()) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                cancelCallback: _endEdit,
                confirmCallback: function () {
                    OrganizationActions.edit(OrganizationStore.getCurrentParent());
                }
            });
        } else {
            _endEdit();
        }
    },

    edit(parent: IOrganizationBase, callback?: any) {
        if (!SystemStore.isActionInProgress(OrganizationConstants.ORGANIZATION_EDIT)) {
            SystemActions.beginAction(OrganizationConstants.ORGANIZATION_EDIT);

            OrganizationService.editOrganization(OrganizationStore.getEditOrganization(),
                function (data) {
                    if (parent == null) {
                        //Hard coded for now
                        OrganizationActions.getAllRoot(5);
                    } else {
                        OrganizationActions.getChildren(parent);
                    }

                    if (callback !== undefined && callback != null) {
                        callback();
                    }

                    _endEdit();
                    SystemActions.endAction(OrganizationConstants.ORGANIZATION_EDIT);
                },
                function (error) {
                    SystemActions.endAction(OrganizationConstants.ORGANIZATION_EDIT);
                });
        }
    },

    update(key: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: OrganizationConstants.ORGANIZATION_UPDATE_ORGANIZATION,
            key: key,
            value: value
        });
    }
};

export default OrganizationActions;
